import React from 'react';

const FilterFormParentComponent = ({ children, icon, title }) => {
  return (
    <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12">
      <div className="form-group">
        <div className="input-group">
          <div className="input-group-prepend" title={title}>
            <span className="input-group-text">
              <i className={`wb ${icon}`}></i>
              <span className="required"> *</span>
            </span>
          </div>
          {children}
        </div>
      </div>
    </div>
  );
};

export default FilterFormParentComponent;
